import apiClient from './client';

/**
 * GET /api/cases/:caseNumber/red-flags
 * Returns all red-flag detail rows for the case's connected component.
 * Shape: { summaries, rf01_details, rf02_details, rf03_details, rf04_details }
 */
export const fetchCaseRedFlags = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}/red-flags`);
  return data;
};
